<template>
  <div class="height-100 d-flex">
    <div class="authCard m-auto">
      <a href="https://smartstewards.com/" target="_blank"><img src="@/assets/smart-stewards.png" class="header-logo"
      height="85" width="85" alt="Logo"></a>
      <h3>Sign Up</h3>
      <!-- <p class="primary">An annual subscription fee of ₦99,950 is required to complete your
        registration.</p> -->

      <form class="auth-form" @submit="register">
        <div class="form-group">
          <input type="text" v-model="firstname" placeholder="First Name" class="form-control"
          required>
        </div>

         <div class="form-group">
          <input type="text" v-model="lastname" placeholder="Last Name" class="form-control"
          required>
        </div>

        <div class="form-group">
          <input type="tel" v-model="phone" placeholder="Phone Number" class="form-control"
          required>
           <p v-if="phoneerror" class="error-msg">Phone number has been used already</p>
        </div>

        <div class="form-group">
          <input type="email" v-model="email" placeholder="Email Address" class="form-control"
          required>
          <p v-if="emailerror" class="error-msg">Email Address has been used already</p>
        </div>

        <div class="form-group">
          <input type="password" v-model="password" placeholder="Password" class="form-control"
          required>
        </div>

        <div>
          <button class="btn primary-btn btn-block" :disabled="isDisabled">
          <span v-if="!loading">SIGN UP</span>
          <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
          </vue-loaders-ball-spin-fade-loader>
          </button>
        </div>
      </form>
      <p><span class="secondary-text">Already have an account?</span><router-link to="/signin">
      Sign in </router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.email || !this.password || !this.phone || !this.firstname) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      firstname: '',
      lastname: '',
      phone: '',
      email: '',
      password: '',
      loading: false,
      phoneerror: false,
      emailerror: false,
      referralCode: '',
    };
  },
  mounted() {
    // this.referralCode = this.$route.query.referral;
    const urlParams = new URLSearchParams(window.location.search);
    this.referralCode = urlParams.get('referral');
  },
  methods: {
    register(e) {
      e.preventDefault();
      this.loading = true;
      this.phoneerror = false;
      this.emailerror = false;
      const data = {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        phone: this.phone,
        password: this.password,
        inviteCode: this.referralCode,
        userType: 'smart-mina',
      };
      this.$store.dispatch('register', data).then(() => {
        this.loading = false;
        this.$router.push('/');
      }).catch((err) => {
        console.log(err);
        this.loading = false;
        if (err.data.error === 'phone') {
          this.phoneerror = true;
        } else {
          this.emailerror = true;
        }
        this.error = true;
      });
    },
  },
};
</script>

<style scoped>
  .d-flex{
    background-color: #FFF;
  }
</style>
